import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=7c9d02ce&scoped=true&"
import script from "./forum.vue?vue&type=script&lang=js&"
export * from "./forum.vue?vue&type=script&lang=js&"
import style0 from "./forum.vue?vue&type=style&index=0&lang=less&"
import style1 from "./forum.vue?vue&type=style&index=1&id=7c9d02ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d02ce",
  null
  
)

export default component.exports